export default __webpack_public_path__ + "static/12-b732b1ccbe66a501a424fb9074430ed0.jpg";